import React, { useState, useEffect } from "react";
import { successPageImge } from "assets/img";
import onboardingStore from "mobXstore/onboardingStore";
import FreshChatComponent from "components/freshChat/FreshChat";

const Step6 = () => {
  const [userAlreadyRegistered, setUserAlreadyRegisterd] = useState(
    !onboardingStore.isAlreadyRegistered
  );

  useEffect(() => {
    setUserAlreadyRegisterd(!onboardingStore.isAlreadyRegistered);
  }, [onboardingStore.isAlreadyRegistered]);

  useEffect(() => {
    onboardingStore.handleReset();
  }, []);

  return (
    <>
      <div
        className={`flex flex-col items-center justify-center text-center ${
          userAlreadyRegistered ? "pt-16" : "pt-32"
        } pb-16`}
      >
        <div className="w-full flex items-center justify-center">
          <img
            src={successPageImge}
            alt="imageStep6"
            className="w-44 h-44"
          ></img>
        </div>

        <div className="text-neutral-700 text-2xl font-inter-semibold leading-loose py-2">
          Thank you!
        </div>

        {userAlreadyRegistered ? (
          <div className="text-slate-700 font-inter-normal text-base w-58 screen-lg:w-96 screen-md:w-96">
            {/* for lg and md screens */}
            <p className="screen-lg:inline screen-md:inline hidden">
              Please check your email (including your spam folder) for the link
              to log in and manage your meal plan.
              <br />
              The email you have used to create this account already exists. We
              have added a new office under your profile, but have not changed
              any of your existing user settings. To make changes to your user
              profile, please visit the profile page or start a live chat.
            </p>

            {/* for sm screens */}
            <p className="screen-lg:hidden screen-md:hidden screen-sm:inline">
              Please check your email
              <br />
              (including your spam folder) for
              <br />
              the link to log in and manage your
              <br /> meal plan. The email you have used <br /> to create this
              account already exists. <br />
              We have added a new office under your profile, but have not user
              profile, please visit the profile page or start a live chat.
            </p>
          </div>
        ) : (
          <div className="text-slate-700 font-inter-normal text-base w-58 screen-lg:w-96 screen-md:w-96">
            {/* for lg and md screens */}
            <p className="screen-lg:inline screen-md:inline hidden">
              Please check your email (including your spam folder) for the link
              to log in and manage your meal plan.
            </p>

            {/* for sm screens */}
            <p className="screen-lg:hidden screen-md:hidden screen-sm:inline">
              Please check your email
              <br />
              (including your spam folder) for
              <br />
              the link to log in and manage your
              <br /> meal plan.
            </p>
          </div>
        )}
      </div>
      <FreshChatComponent />
    </>
  );
};

export default Step6;
